import { z } from "zod";

/**
 * Valid section IDs.
 */
export const sectionIdSchema = z.enum([
  "hero",
  "features",
  "services",
  "about",
  "testimonials",
  "reviews",
  "newsletter",
  "blog",
  "team",
  "logoCloud",
  "pricing",
  "faq",
  "contact",
  "events",
  "eventBooking",
  "ctaBar",
  "timeline",
]);

/**
 * Zod schema for HomepageLayoutConfig.
 */
export const homepageLayoutConfigSchema = z.object({
  homepageSections: z.array(sectionIdSchema),
});
